exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "agm-map {\r\n    width: 100%;\r\n    height: 80vh;\r\n    \r\n}\r\n\r\n.els-legend {\r\n    background-color: rgba(255, 255, 255, .75);\r\n    padding: 20px;\r\n    margin: 10px;\r\n    border-radius: 10px;\r\n}\r\n\r\n.legend-img {\r\n    vertical-align: middle;\r\n    width: 20px !important;\r\n    height: auto !important;\r\n}\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/views/admin/map-location/map-location.component.css
// module id = 981
// module chunks = 0